// extracted by mini-css-extract-plugin
module.exports = {"disabled":"styles_disabled__qKnkN","disabled--full-width":"styles_disabled--full-width__zlS2C"};